
import { Component, Vue } from 'vue-property-decorator'
import { AppModule } from '@/store/module'

import InfoBlock from './components/InfoBlock.vue'
import Banner from '@/views/sale/components/Banner.vue'
import ContactBlock from '@/components/ContactBlock.vue'
import HelpBlock from '@/components/HelpBlock.vue'
import FooterBlock from '@/components/FooterBlock.vue'
import AppDownload from './components/AppDownload.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'

@Component({
  components: {
    InfoBlock,
    Banner,
    ContactBlock,
    HelpBlock,
    FooterBlock,
    AppDownload,
    Breadcrumb
  },
})
export default class Member extends Vue {

  breadcrumbItems = [
    { label: '首頁', to: '/' },
    { label: '等味排隊' }
  ]

  get bannerData() {
    return {
      imgH5: require('@/assets/sale/dengwei-h5-clean.png'),
      imgPc: require('@/assets/sale/dengwei-pc.jpg'),
      alt: '「等味」餐飲智能排隊，讓等味更方便·省時',
      title: '「等味」餐飲智能排隊\n讓等味更方便·省時',
      subtitle: '餐廳排隊管理App',
      copyColor: '#000000',
      mobileCopyAlign: 'center',
    }
  }

  get isH5() {
    return AppModule.isH5
  }

  get images() {
    return [
      'https://spics.inctrip.com/6e612827fede85d6ce48187dc71e1e78.png',
      'https://spics.inctrip.com/8bdbef5c193b550c9ef0b28299586601.png',
      'https://spics.inctrip.com/476d69a3b55e700661b623531dbe347e.png',
      'https://spics.inctrip.com/84626cf791f99cb398e697b1d7c6f5d5.png'
    ]
  }

}
